import { List, Record } from "immutable";

export const COURSE_SECTIONS_SPEC_TYPE: "course-sections" = "course-sections";

export type CourseSectionsSpecType = {
  courseId: string | null;
  sectionIds: List<string>;
  questionIds: List<string>;
};

type CourseSectionsSpecJS = {
  courseId: string;
  sectionIds: string[];
  questionIds: string[];
};

const defaultCourseSectionsSpec: CourseSectionsSpecType = {
  courseId: null,
  sectionIds: List(),
  questionIds: List()
};

export default class CourseSectionsSpec extends Record(
  defaultCourseSectionsSpec
) {}

export function fromJS(values: CourseSectionsSpecJS): CourseSectionsSpec {
  return new CourseSectionsSpec({
    ...values,
    sectionIds: List(values.sectionIds),
    questionIds: List(values.questionIds)
  });
}
